import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { CONSTANTS__environment_client } from '@/constants/CONSTANTS__environment_client';
import { assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { BuilderLogEntry } from '@shared/logger/builder_log_entry';
import { ILogMessageParams } from '@shared/logger/i_log_message_params';
import { LogEntryError } from '@shared/logger/log_entry_error';
import { NewRelicTransport } from '@shared/logger/new_relic_transport';
import { ServiceLoggerBase } from '@shared/logger/service_logger_base';
import { format_timestamp_HH_mm_ss, timestamp_ms } from '@shared/utils/utils_time';

export class ServiceLoggerNewRelicClient extends ServiceLoggerBase {
  private readonly new_relic_transport: NewRelicTransport;

  constructor() {
    super();

    let { VITE_SERVICE_NEW_RELIC_LICENSE_KEY, VITE_SERVICE_ULTIMATEDIFFUSION_HTTP_URL_BASE } = CONSTANTS__environment_client;

    assert_string_not_empty(VITE_SERVICE_NEW_RELIC_LICENSE_KEY);

    this.new_relic_transport = new NewRelicTransport(VITE_SERVICE_NEW_RELIC_LICENSE_KEY, VITE_SERVICE_ULTIMATEDIFFUSION_HTTP_URL_BASE + ' - client');
  }

  protected log_info_internal(message_original: string, params: ILogMessageParams) {
    let log_entry = BuilderLogEntry.build(message_original, params);

    let { message } = log_entry;

    let new_relic_params = this.get_new_relic_params();

    this.new_relic_transport.sendLog('info', message, { ...new_relic_params });
  }

  protected log_warning_internal(message_original: string, params: ILogMessageParams) {
    let log_entry = BuilderLogEntry.build(message_original, params);

    let new_relic_params = this.get_new_relic_params();

    let { message } = log_entry;

    this.new_relic_transport.sendLog('warn', message, { ...new_relic_params });
  }

  protected log_error_internal(log_entry: LogEntryError, params: ILogMessageParams) {
    let message = log_entry.content.join('\n');

    let new_relic_params = this.get_new_relic_params();

    this.new_relic_transport.sendLog('error', message, { ...new_relic_params });
  }

  private get_new_relic_params() {
    let timestamp = timestamp_ms();
    let timestamp_string = format_timestamp_HH_mm_ss(timestamp);

    return {
      user_id: CONSTANTS__client.LOGGER_USER_ID,
      connection_id: CONSTANTS__client.LOGGER_CONNECTION_ID,
      timestamp,
      timestamp_string,
    };
  }
}
